// src/stores/useRecheckAoiPref.js
//
// The re-checker's last operating AOI, remembered across sessions: the same
// mechanism as WellFinder Review's (useWellfinderAoiPref, which says why it is
// a persisted store and why it is not the filter), under its own USER-scoped
// key. The re-check page's filter is the URL's ?aoi=; this seeds it on
// arrival and nothing else.

import { create } from "zustand";
import { persist } from "zustand/middleware";
import { PERSIST_KEYS } from "../auth/persistKeys";

export const useRecheckAoiPref = create(
  persist(
    (set) => ({
      lastAoiId: null,
      rememberAoi: (id) => set({ lastAoiId: id ?? null }),
    }),
    { name: PERSIST_KEYS.recheckAoi },
  ),
);
